export const constants = {
  DEV_TIMEOUT: 43020000,
  ACTUAL_TIMEOUT: 43020000,
  TRADESTATE_SLEEP_DELAY: 0,
  UI_STATUS_SENT: "Sent",
  UI_STATUS_BOOKED: "Booked",
  UI_STATUS_NEW: "New",
  UI_STATUS_WARNING: "Warning",
  UI_STATUS_FAILED: "Failed",
  minIconContract: "minimizeIconContract",
  minIconContractfalse: "minimizeIconContractFalse",
  subheadermatchClass: "SubHeaderMainDiv",
  subheaderNonmatchClass: "SubHeaderNonMatchdDiv",
  Loan: "loan",
  CPTY: "cpty",
  Trade: "trade",
  SecMaster: "SecMaster",
  ContractActivity: "ContractActivity",
  FilterMenuTab: "filterMenuTab",
  Tab: "Tab",
  arraybuffer: "arraybuffer",
  Date_Format: "MM/DD/YYYY",
  NumpadSubtract: "NumpadSubtract",
  Minus: "Minus",
  Hse_ind: "U",
  Hse_Rnd: "1",
  clickaway: "clickaway",
  Error: "Error",
  DtcIn: "dtcIn",
  DtcOut: "dtcOut",
  DtcSummary: "dtcSummary",
  RefreshFormat: "MM/DD/yyyy HH:mm",
  DateTimeFormat: "MM/DD/yyyy HH:mm:ss",
  swalIconError: 'error',
  PROFIT_CENTER: "PROFIT_CENTER",
  MARK_TO_MARKET: "MARK_TO_MARKET",
  RECALL:'RECALL',
  RETURN:'RETURN',
  REBATE_RATE: "REBATE_RATE",
  swalIconSuccess: 'success',
  updateContractPCSuccess: 'Contract(s) Update request is successfully queued',
  RATE_CHANGE_ABSOLUTE: "absolute",
  RATE_CHANGE_RELATIVE: "relative",
  RATE_CHANGE_INLINE: "inline",
  ADMIN_RATE: "ADMIN_RATE",
  CONTRACT_UPDATE: "CONTRACT_UPDATE",
  MARK_PARAMETER_AMOUNT: "MARK_PARAMETER_AMOUNT",
  DIVIDEND_FLOW_THRU_RATE: "DIVIDEND_FLOW_THRU_RATE",
  TERM_DATE: "TERM_DATE",
  CONTRACT_MAINTENANCE_REQUEST: "CONTRACT_MAINTENANCE_REQUEST",
  Period:"Period",
  DateTimeDBFormat: 'YYYY-MM-DD HH:mm:ss',
  DateDBFormat: 'YYYY-MM-DD',
  TimeDBFormat: 'HH:mm:ss',
  
  
};

export const messages = {
  contractBookMessage:
    "Currently contract booking service is down. Please try after sometime. If problem persists please email to stockloandev@matrixapps.",
  contractServiceDownMessage:
    "There is a problem with SL Trader, the team is aware of the issue and is working on it. Please check back in 15 minutes. If problem persists please email stockloandev@matrixapps.com",
  LoanetDownMessage:
    "Loanet is currently offline, you can place trades but they will be booked when the exchange opens at 5:30 am on weekdays",
  TickerDownMessage:
    "Ticker data is not available currently. Please try after sometime. If problem persists please email stockloandev@matrixapps.com",
  CPTYDownMessage:
    "Counter Party data is not available currently. Please try after sometime. If problem persists please email stockloandev@matrixapps.com",
     SecMasterDownMessage:
    'Security master data is not available currently. Please try after sometime. If problem persists please email support@sltrader.com',
  statuserror:
    "There was an issue with your request. Please try again. If you encounter the same error please email StockloanDev@matrixapps.com.",
  singleTradeValidationMessage: "Please enter the value",
  enterPositiveNumberMessage: "Please enter positive number",
  enterValidRate: "Please enter valid rate",
  selectFutureDateMessage: "Please select future date",
  enterBLMessage: "Please enter B/L",
  Date_validation: "Please select future date",
  RateValidation: "please enter valid rate",
  InvalidContract: "Invalid Contract Type (B/L)",
  InvalidTicker: "Invalid Ticker",
  InvalidCPTY: "Invalid CPTY",
  InvalidCreditLimit: "Credit Limit Exceeded",
  InvalidRate: "Invalid Rate",
  InvalidQuantity: "Invalid Quantity",
  PastTermDate: "Term Date in the Past",
  InvalidTermDate: "Invalid Term Date",
  InvalidValue: "Invalid Value",
  InvalidCollatral: "Invalid Collatoral Code",
  TemplateMessage: "Please Check your excel file template",
  InvalidUsername: "Invalid username or password",
  SuccessMessgae: "Successful",
  enterPositiveInteger: "Please enter positive integer number",
  InvalidContractValue: "Invalid Contract Value",
  tradeManagementMessage:
    "Currently trade state management service is down. Please try after sometime. If problem persists please email to stockloandev@matrixapps.",
  userManagementService: 'User management service is down. Please try after sometime. If problem persists please email to stockloandev@matrixapps.',
  loanetServiceDown:
    "Currently loanet contract maintenance service is down. Please try after sometime. If problem persists please email to stockloandev@matrixapps.",
  dtcServiceDown: "Currently dtc settlement service is down. Please try after sometime. If problem persists please email to stockloandev@matrixapps.",
  returnsServiceDown: "Currently returns service is down. Please try after sometime. If problem persists please email to stockloandev@matrixapps.",
  recallsServiceDown: "Currently recalls service is down. Please try after sometime. If problem persists please email to stockloandev@matrixapps.",
serviceDownMessage:
    ' service is currently down. Please try after sometime. If problem persists please email to support@sltrader.com.',
  lemurServiceDown:
    'Currently lemur service is down. Please try after sometime. If problem persists please email to stockloandev@matrixapps.'  
};

export const quantityConfig = {
  min: 1,
  max: 999999999999,
};
export const rateConfig = {
  min: -999.9999,
  max: 999.9999,
};

export const markConfig = {
  min: 95,
  max: 105,
};

export const divConfig = {
  min: 0,
  max: 999,
};

export const dtcStatusColors = {
  RAD: '#FFEED4',
  approved: '#BBDEFB',
  pended: '#FFFBD5',
  settled: '#D4EBD4',
  reversed: '#E1E1E1',
  dropped: '#E9E9E9',
  nonCcf: '#DEDBD9',
  canceled: '#FADCD9'
}

export const lnetStatusColors = {
  match: '#D4EBD4',
  nonMatch: '#FFEED4',
  o: ''
}

export const metricFilters = {
  allocated: 'allocated',
  unallocated: 'unallocated',
  settled: 'settled',
  unsettled: 'unsettled',
  buyIn: 'buyIn',
  fullyReturned: 'fullyReturned'
}

export const recallMetricFilters = {
  recall: 'recall',
  termination: 'termination',
  open:'open',
  pastDue:'pastDue',
  past30dayDue:'past30dayDue',
  partialReturn:'partialReturn',
  fullReturn:'fullReturn',
  nonOutStanding:'nonOutStanding',
  fullRecall: 'fullRecall'
}

export const status = {
  new: '#FFFFFF',
  sent: '#FFEED4',
  failed: '#FFBCC3',
  warning: '#FFFBD5',
  booked: '#D4EBD4',  //'#DBEEFD',
  error: '#FFDEE1',
  settled: '#D4EBD4'
}

export const contractUpdateTitle = {
  profitCenter: 'Profit Center',
  rateChange: 'Rebate Rate',
  markToMark: 'Mark to Mark',
  adminRate: 'Rerate the Book'
}

export const env = {
  Dev: 'Development',
  QA: 'QA',
  Prod: 'Production',
}

export type BarUnit = {
  type: string
  series: [{ data: any[] }]
  labels: string[]
}
export const LocateTabs = {
  locatesApproved: 'Locates-Approved',
  locatesUsed: 'Locates-Used',
  preBorrow: 'Pre-Borrow'
}

export const headers = {
  'Content-Type': 'application/json'
}

export const EndPoint = {
  signIn: 'signin',
  refreshToken: 'refreshtoken',
  callbacks: '/callback?account_id=',
  returns: '/returns?account_id=',
  changePassword: 'changePassword',
  signOut: 'signout',
  secMaster: '/getSecMaster',
  cptyMaster: '/getCptyDetails',
  loansAndBorrows: '/getAllOpenContractsByType',
  dtcSummary: '/getDTCBoxSummary?account_id=',
  dtcActivity: '/getDTCIncomingActivity?account_id=',
  dtcContractActivity: '/getLoanetSettleContractActivity?account_id=',
  reportFn: '/getReportDataByFnName',
  getReportConfig: '/getReportConfig',
  contractMaintenance: '/updateContract',
  contractMaintenanceUpdate: '/contractMaintenanceRequest',
  contractActivity: '/fetchContractActivity?contractId=',
  actuator: 'actuator/health',
  contractStatus: '/contractStatus',
  bookContract: '/bookContract',
  saveTradeStateList: 'saveTradeStateList',
  deleteTradeState: 'deleteTradeState',
  updateTradeState: 'updateTradeState',
  getCptyDetails: '/getCptyDetails',
  contractBrowserKPI: '/fetchStockLoanKPI?account_id=',
  getTradesState: 'getTradesState',
  getOpenContractValueByCptyID: 'getOpenContractValueByCptyID',
  recallActivity: '/getgetRecallActivityByLenderId',
  recallLoans: 'getRecallDetailsAndOutstandingLoans',
  recallBorrows: 'getRecallDetails',
  getUsersList: 'getUsersByClientAndAccount',
  authBase: '/api/',
  getRolesList: 'getRoleDetails',
  deleteUser: 'deleteUser',
  signUp: '/signup',
  updateUser: 'updateUserAndRole',
  getPermissionsList: 'getPermissionDetails',
  getPermissionByRole: 'getPermissionByRole',
  modifyPermission: 'modifyPermission',
  modifyRole: 'modifyRole',
  modifyRoleToPermission: 'modifyRoleToPermission',
  getLenderDetails: '/getLenderDetails',
  getRateDetails: '/getRateDetails',
  getLocateLists: '/getLocateLists',
  getPreBorrows: '/getPreBorrows',
  saveLocateApproved: '/saveLocateApproved',
  sendQuoteInquiry: '/send-Quote-Inquiry',
  getLenders: "/getLenders",
  sendRestLocateRequest: '/send-Rest-Locate-Request',
  savePreBorrow: '/savePreBorrow',
  getInventory: '/getInventory',
  getMostLocate: '/getMostLocate',
  saveLenderDetailsList: '/saveLenderDetailsList',
  getLocateKPI: '/getLocateKpi',
  saveRateDetailsList: '/saveRateDetailsList',
  updateRateDetailsList: '/updateRateDetailsList',
  saveSecMasterDetails: '/saveSecMasterDetails',
  updateSecMasterDetails: '/updateSecMasterDetails',
  saveCPTYDetails: '/saveCptyDetails',
  updateCPTYDetails: '/updateCptyDetails',
  generateOtp: 'generateOtp?userId=',
  restPassword: 'resetPassword',
  eureka: '/eureka/apps',
  getAutoborrowBatchDetails: '/api/getAutoborrowBatchDetails',
  getAutoborrowOrderDetails: '/api/getAutoborrowOrderDetails',
  submitTradeBatch: '/api/submitTradeBatch',
  createBulkTradeRecords: '/api/createBulkTradeRecords',
  fetchBatchTimeline: '/api/fetchBatchTimeline',
  fetchAbCptyId: '/api/fetchAbCptyId',
  getClientEntityDetails: 'getClientEntityDetails',
  updateLocateApproved: '/updateLocateApproved',
  changePasswordByAdmin: 'changePasswordByAdmin',
  saveQuoteInquiry:'/saveQuoteInquiry',
  sendOrderRequest:'/send-Order-Request',
  saveOrderRequest:'/saveOrderRequest',
  sendRestAvailabilityInquiry: '/send-Rest-Availability-Inquiry',
  clearLocateRecords:'/clearLocateRecords',
  getAvailableQuantity:'/getAvailableQuantity',
  getInquiryList:'/getInquiryLists',
  lenderReplenish:'/lenderReplenish',
  holdReleaseAvailableLocate:'/holdReleaseAvailableLocate',
    lemurReport: '/report/getreportdatabyfnname',
  saveRiskCpty: '/counterparties',
  workflowsRun: '/workflows/run',
   securities: '/securities',
}

export const LocateStatus = {
  Approved: 'Approved',
  Pending: 'Pending',
  Rejected: 'Rejected',
  Override: 'Override',
  Partial: 'Partial',
  New: 'New',
  Available: 'Available',
  UnAvailable: 'UnAvailable',
  Topup:'Top-up',
  Error:'Error'
}

export const TradeStatus = {
  new: '#FFFFFF',
  sent: '#FFEED4',
  failed: '#FFBCC3',
  warning: '#FFFBD5',
  booked: '#D4EBD4',
  error: '#FFDEE1',
  settled: '#D4EBD4'
}

export const LemurContractFilterTabs = {
  priceLessThan2: 'Price < 2',
  adtv10days: 'Qty%ADTV > 10%',
  daysToLiq: 'DTL > 2',
  stalePrice: 'Stale Price',
  qtyGreaterThan5Float: 'Qty > 5% Float'
}

export const appColor = "#1e355e";

export const socketMsgType = {
  DTC_ACTIVITY: 'DTC_ACTIVITY',
  MATCH_CONTRACT_ACTIVITY: 'MATCH_CONTRACT_ACTIVITY',
  DTC_INTRADAY_SUMMARY: 'DTC_INTRADAY_SUMMARY',
  DTC_CALLBACK_MATCH: 'DTC_CALLBACK_MATCH',
  CONTRACT_ACTIVITY: 'CONTRACT_ACTIVITY',
  CONTRACT: 'CONTRACT',
  RETURN: 'RETURN',
  RECALL: 'RECALL',
  CALLBACK: 'CALLBACK',
  ORDER: 'LOCATE_ORDER',
  LOCATE_INQUIRY:'LOCATE_INQUIRY',
  QUOTE_REQUEST:'QUOTE_REQUEST',
  CONTRACT_UPDATES_RETURN: 'CONTRACT_UPDATES_RETURN',
  CONTRACT_UPDATES_RECALL:'CONTRACT_UPDATES_RECALL',
  LOCATE_ORDER_UPDATE:'LOCATE_ORDER_UPDATE'
}

export const contractBrowserFilters = {
  buy_in : "buy_in",
  recall: "recall"
}

export const consoleClearTime = 1200000  //time in milliseconds

export const VALID_RATINGS = [
  'AAA',
  'AA+',
  'AA',
  'AA-',
  'A+',
  'A',
  'BBB+',
  'BBB',
  'BBB-',
  'BB+',
  'BB',
  'BB-',
  'B+',
  'B',
  'B-',
  'CCC+',
  'CCC',
  'CCC-',
  'CC',
  'C',
  'D'
] as const